import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Card, Box, Button, Stack, TextField, Autocomplete, Typography } from "@mui/material";
import MDTypography from "components/MDTypography";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import fetchData from "verticales/FetchData";
import { Dialog, DialogContentText } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import AppLoading from "verticales/AppLoading.tsx";

const context = "ec2-aws-start-stop";
const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
var opcionesInstances: Array<{ title: string }> = [];
var cuentaSelectStopStart = "none";

const ViewNewEdit = (props: any) => {
  const [instanceId, setInstanceId] = useState(
    props.row.original ? props.row.original.instance_id : ""
  );
  const [instancia, setInstance] = useState(
    props.row.original ? props.row.original.instance_name : ""
  );
  const [instanceType, setInstanceType] = useState(
    props.row.original ? props.row.original.instance_type : ""
  );
  const [horaApagado, setHoraApagado] = useState(
    props.row.original ? props.row.original.hora_apagado : 0
  );
  const [horaEncendido, setHoraEncendido] = useState(
    props.row.original ? props.row.original.hora_encendido : 0
  );

  const [dias, setDias] = useState(props.row.original ? props.row.original.dias : "");
  const [comentario, setComentario] = useState(
    props.row.original ? props.row.original.comentario : ""
  );
  const [feActualizacion, setFeActualizacion] = useState(
    props.row.original ? props.row.original.fecha_actualizacion : ""
  );
  const [feCrecion, setFeCrecion] = useState(
    props.row.original ? props.row.original.fecha_creacion : ""
  );
  const [blocking, setBlocking] = useState(false);
  const [msgAction, setMsgAction] = useState(context);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({
    instancia: false,
    horaApagado: false,
    horaEncendido: false,
    dias: false,
  });

  useEffect(() => {
    if (!Array.isArray(props.dataInstance)) {
      console.error("dataInstance is not an array:", props.dataInstance);
      return;
    }
    if (opcionesInstances.length === 0 || props.cuentaSelect !== cuentaSelectStopStart) {
      opcionesInstances = [];
      for (let objInsEc2 of props.dataInstance) {
        opcionesInstances.push({ title: objInsEc2.title });
      }
      cuentaSelectStopStart = props.cuentaSelect;
    }
  }, [props.dataInstance, props.cuentaSelect]);

  const validateDias = (value: string) => {
    const regex = /^\[([0-6](,[0-6])*)?\]$/;
    const isValidFormat = regex.test(value);
    if (!isValidFormat || value === "[]") return false;

    const numbers = value.slice(1, -1).split(",").map(Number);
    const uniqueNumbers = new Set(numbers);
    return numbers.length === uniqueNumbers.size;
  };

  const handleDelete = async () => {
    const params = {
      action: "DELETE",
      object: {
        id: rowToDelete.original ? rowToDelete.original.id : -1,
      },
    };
    setBlocking(true);
    setMsgAction("eliminando");
    let resp = await fetchData(url, context, params);
    setBlocking(false);
    setOpenConfirmDelete(false);
    await loadList(cuentaSelect);
  };

  const handleBlur = () => {
    const isValid = validateDias(dias);
    if (!isValid) {
      setErrors({ ...errors, dias: true });
    }
  };

  const handleAccept = async () => {
    const newErrors = {
      instancia: instancia === "",
      horaApagado: horaApagado === -1,
      horaEncendido: horaEncendido === -1,
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      setErrorMessage("Los campos son requeridos.");
      return;
    } else {
      setErrorMessage("");
    }

    if (horaEncendido === horaApagado) {
      setErrorMessage("La hora de encendido y apagado no pueden ser iguales.");
      return;
    }

    const isValid = validateDias(dias);
    if (!isValid) {
      setErrors((prevErrors) => ({ ...prevErrors, dias: true }));
      setErrorMessage("Formato inválido. Debe ser [1,2,3,4]");
      return;
    }

    const params = {
      action: props.row.original ? "UPDATE" : "INSERT",
      object: {
        instanceId,
        instancia,
        instanceType,
        horaApagado,
        horaEncendido,
        dias,
        comentario,
        cuenta: props.cuentaSelect,
        feActualizacion: new Date(),
        feCrecion: props.row.original ? feCrecion : new Date(),
        id: props.row.original ? props.row.original.id : -1,
      },
    };

    setBlocking(true);
    setMsgAction(props.row.original ? "Actualizando" : "Insertando");
    const resp = await fetchData(url, context, params);
    setBlocking(false);
    console.log("result", resp);
    props.handleCloseModal(true);
  };
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
              >
                <MDTypography variant="h4" color="white">
                  Instancia
                </MDTypography>
                <IconButton
                  aria-label="close"
                  onClick={() => props.handleCloseModal(false)}
                  sx={(theme) => ({
                    color: theme.palette.common.white,
                  })}
                >
                  <CloseIcon />
                </IconButton>
              </MDBox>
              {blocking ? (
                <AppLoading titleCustom={"Ec2-Aws_Start-Stop"} />
              ) : (
                <Box
                  component="form"
                  sx={{ "& .MuiTextField-root": { m: 1 }, width: 480, textAlign: "center" }}
                  noValidate
                  autoComplete="off"
                >
                  <Grid maxWidth="sm">
                    <Autocomplete
                      disablePortal
                      style={{ width: 460 }}
                      options={opcionesInstances.map((option) => option.title)}
                      renderInput={(params) => (
                        <TextField {...params} label="Instancia EC2" error={errors.instancia} />
                      )}
                      onChange={(event, newValue) => {
                        const objInstance = props.dataInstance.find(
                          (option) => option.title === newValue
                        );
                        if (objInstance) {
                          setInstanceId(objInstance.instance_id);
                          setInstance(objInstance.instance_name);
                          setInstanceType(objInstance.instance_type);
                          setFeActualizacion("");
                        }
                      }}
                    />
                  </Grid>
                  <TextField
                    size="small"
                    value={instanceId}
                    disabled
                    label="Instance ID"
                    style={{ width: 223 }}
                  />
                  <TextField
                    size="small"
                    value={instanceType}
                    disabled
                    label="Instance Type"
                    style={{ width: 223 }}
                  />
                  <TextField style={{ width: 460 }} value={instancia} disabled label="Instancia" />
                  <TextField
                    size="small"
                    value={horaEncendido}
                    type="number"
                    label="Hora Encendido"
                    style={{ width: 223 }}
                    inputProps={{ min: 0, max: 23, step: 1 }}
                    onChange={(e) =>
                      setHoraEncendido(Math.max(0, Math.min(23, parseInt(e.target.value))))
                    }
                    error={errors.horaEncendido}
                  />
                  <TextField
                    size="small"
                    value={horaApagado}
                    type="number"
                    label="Hora Apagado"
                    style={{ width: 223 }}
                    inputProps={{ min: 0, max: 23, step: 1 }}
                    onChange={(e) =>
                      setHoraApagado(Math.max(0, Math.min(23, parseInt(e.target.value))))
                    }
                    error={errors.horaApagado}
                  />
                  <TextField
                    size="small"
                    value={dias}
                    label="Días"
                    onChange={(e) => setDias(e.target.value)}
                    onBlur={handleBlur}
                    style={{ width: 223 }}
                    error={errors.dias}
                    helperText={errors.dias ? "Error. Debe ser [1,2,3,4,5,6,0]" : ""}
                  />
                  <TextField
                    size="small"
                    value={comentario}
                    style={{ width: 223 }}
                    label="Comentario"
                    onChange={(e) => setComentario(e.target.value)}
                  />
                  <TextField
                    size="small"
                    value={feActualizacion}
                    style={{ width: 223 }}
                    disabled
                    label="Fecha Actualización"
                  />
                  <TextField
                    size="small"
                    value={feCrecion}
                    disabled
                    label="Fecha Creación"
                    style={{ width: 223 }}
                  />

                  <Stack justifyContent="right" direction="row" sx={{ p: 1 }}>
                    {errorMessage && (
                      <Typography color="error" variant="body2" sx={{ ml: 2 }}>
                        {errorMessage}
                      </Typography>
                    )}
                    <MDButton disableElevation onClick={props.handleCloseModal}>
                      <MDTypography>Cancelar</MDTypography>
                    </MDButton>
                    <MDButton disableElevation onClick={handleAccept}>
                      <MDTypography>Aceptar</MDTypography>
                    </MDButton>
                  </Stack>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};
export default ViewNewEdit;
